import React, { Component } from "react";
import { View, TextInput } from "react-native";
import {  componentStyles } from '../theme/styles'
class EditText extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <View style={this.props.style}>
                <TextInput
                    underlineColorAndroid="transparent"
                    keyboardType={this.props.inputType}
                    placeholder={this.props.hint}
                    returnKeyType='done'
                    editable={this.props.editable ? this.props.editable : true}
                    placeholderTextColor={this.props.hintColor ? this.props.hintColor : '#B4B4B4'}
                    style={[{ textAlign: 'center',outlineWidth:0 }, this.props.isbold ? componentStyles.textBold : componentStyles.text, this.props.textStyle]}
                    multiline={this.props.multiline != null}
                    onChangeText={text => this.props.onChangeText(text)}
                    value={this.props.value}
                />
            </View>
        );
    }
}


export default EditText;
